import { useEffect, useState } from 'react';
import differenceInMilliseconds from 'date-fns/differenceInMilliseconds';

interface useTimeTableProps {
  schedule: string[];
  action: () => void;
  isUserRegistered: boolean;
}

const useTimeTable = ({ schedule, action, isUserRegistered }: useTimeTableProps) => {
  const [currentScheduled, setCurrentScheduled] = useState<any[]>([]);

  const cleanUp = () => {
    if (currentScheduled.length > 0) {
      currentScheduled.map((scheduledAction) => {
        clearTimeout(scheduledAction);
      });
    }
  };

  useEffect(() => {
    if (isUserRegistered) {
      if (currentScheduled?.length) cleanUp();

      if (schedule?.length) {
        const scheduledActions: any[] = [];
        schedule.map((startDate: string) => {
          const triggerDate = differenceInMilliseconds(new Date(startDate), Date.now());
          if (triggerDate > 0 && triggerDate < 2073600000) {
            // max limit of setTimeout is 24 days
            const id = setTimeout(action, triggerDate + 1100);
            scheduledActions.push(id);
          }
        });

        setCurrentScheduled(scheduledActions);
      }
    }

    return () => cleanUp();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [schedule]);
};

export default useTimeTable;
